/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Boundary_TitleInputs */

const en_error_boundary_title = /** @type {(inputs: Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const es_error_boundary_title = /** @type {(inputs: Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salio mal`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Error_Boundary_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const error_boundary_title = /** @type {((inputs?: Error_Boundary_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Boundary_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_boundary_title(inputs)
	return es_error_boundary_title(inputs)
});